import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/i18n/langs/en-US'
import axios from 'axios'
Vue.use(VueI18n)

export const i18n = new VueI18n({
    locale: 'en-US',
    fallbackLocale: 'en-US',
    messages:{
        "en-US": en
    }
})

const loadedLanguages = ['en-US'] // our default language that is preloaded 

function setI18nLanguage(lang) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function loadLanguageAsync(lang) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import( /* webpackChunkName: "[request]"*/ `@/i18n/langs/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}


// WEBPACK FOOTER //
// ./src/i18n/index.js